import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

export type SpotlightContentProps = {
	extensionLocalId: string;
	parameters: SpotlightParameters;
	isInViewMode?: boolean;
	contentId: string;
	experienceName: string;
	createAnalyticsEvent?: CreateUIAnalyticsEvent;
};

export type SpotlightParameters = {
	extensionTitle: string;
	height: SpotlightHeight;
	backgroundColor: string;
	cornerStyle: SpotlightCornerStyle;
	layout: SpotlightLayout;
	content: {
		text: {
			title?: string;
			description?: string;
			color?: string;
		};
		button: {
			displayButton: boolean;
			text?: string;
			link: string;
			style: string;
		};
		image: {
			url?: string;
			altText?: string;
		};
	};
};

export enum SpotlightHeight {
	MEDIUM = 'medium',
	SMALL = 'small',
	LARGE = 'large',
}

export enum SpotlightCornerStyle {
	ROUNDED = 'rounded',
	SQUARED = 'squared',
}

export enum SpotlightLayout {
	SPLIT_IMAGE_RIGHT = 'split-image-right',
	SPLIT_IMAGE_LEFT = 'split-image-left',
	FULL_IMAGE_BACKGROUND = 'full-image-background',
	NO_IMAGE_BACKGROUND = 'no-image-background',
}

export type SpotlightActions = {
	updateHeight: (newValue: SpotlightHeight) => void;
};
